import { render, staticRenderFns } from "./manualReview.vue?vue&type=template&id=1df7deec&scoped=true"
import script from "./manualReview.vue?vue&type=script&lang=js"
export * from "./manualReview.vue?vue&type=script&lang=js"
import style0 from "./manualReview.vue?vue&type=style&index=0&id=1df7deec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df7deec",
  null
  
)

export default component.exports